<template>
  <div class="user-company-dropdown-content">
    <h6>CENTRAL DE COLABORADORES</h6>

    <button
      class="btn-company"
      v-for="company in companies.filter(c => !c.is_blocked)"
      :key="company.id"
      @click="changeCompany(company)"
    >
      {{ company.business.name }}
    </button>
  </div>
</template>

<script>
import { setToken } from "@/setup/api.js";

export default {
  props: {
    companies: Array
  },
  methods: {
    changeCompany(company) {
      setToken(company.access_token.token);
      setTimeout(() => {
        window.location.href = "/";
      }, 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.user-company-dropdown-content {
  h6 {
    padding: 8px 16px;
    font-size: 13px;
    font-weight: normal;
  }

  .btn-company {
    width: 100%;
    background: none;
    text-align: start;
    border: none;
    font-size: 13px;
    font-weight: 700;
    padding: 8px 16px;

    &:hover {
      background-color: rgba(200, 180, 220, 0.2);
    }
  }
}
</style>
